<template>
    <div class="home">
        <div class="content">
            <div class="first_list">
                <div class="content_item">
                    <div class="table" style="width: 100%;height: 100%;">
                        <div class="column header">
                            <el-row class="el-row">
                                <el-col :span="5">
                                    <div class="label"><img class="jf" src="../assets/index@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="label"><img class="jf" src="../assets/name@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="label"><img class="jf" src="../assets/个人销售额@2x.png" alt=""></div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="column_content">
                            <div class="column" v-for="(item) in tableData1" :key="item._id">
                                <el-row>
                                    <el-col :span="5">
                                        <div v-if="item.sort == 1"><img class="icongroup" src="../assets/one@2x.png" alt="">
                                        </div>
                                        <div v-if="item.sort == 2"><img class="icongroup" src="../assets/two@2x.png" alt="">
                                        </div>
                                        <div v-if="item.sort == 3"><img class="icongroup" src="../assets/three@2x.png"
                                                alt="">
                                        </div>
                                        <div v-if="item.sort > 3" class="label-value">{{ item.sort }}</div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="label-value">{{ item.name }}</div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="label-value integral">
                                            <span class="zs">{{thousands(item.value)}}</span>
                                            <!-- <span  class="residue" style="font-size: 18px;">{{ item.residue }}</span> -->
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list_right">
                <div class="content_item">
                    <div class="table" style="width: 100%;height: 100%">
                        <div class="column header">
                            <el-row class="el-row">
                                <el-col :span="5">
                                    <div class="label"><img class="jf" src="../assets/index@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="label"><img class="jf" src="../assets/name@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="label"><img class="jf" src="../assets/个人销售额@2x.png" alt=""></div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="column_content">
                            <div class="column" v-for="(item, index) in tableData2" :key="index">
                                <el-row>
                                    <el-col :span="5">
                                        <div class="label-value">{{ item.sort }}</div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="label-value">{{ item.name }}</div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="label-value integral"><span class="zs">{{thousands(item.value)}}</span></div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="list_right">
                <div class="content_item">
                    <div class="table" style="width: 100%;height: 100%">
                        <div class="column header">
                            <el-row class="el-row">
                                <el-col :span="5">
                                    <div class="label"><img class="jf" src="../assets/index@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="label"><img class="jf" src="../assets/name@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="label"><img class="jf" src="../assets/个人销售额@2x.png" alt=""></div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="column_content">
                            <div class="column" v-for="(item, index) in tableData3" :key="index">
                                <el-row>
                                    <el-col :span="5">
                                        <div class="label-value">{{ item.sort }}</div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="label-value">{{ item.name }}</div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="label-value integral"><span class="zs">{{ thousands(item.value) }}</span></div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="scroll" ref="scroll" :class="messagelist.length > 0 ? 'backlinear' : ''">
                <div :class="{ 'mask': showmask }"></div>
                <div class="background flex space-between">
                    <ul id="ulll">
                        <li v-for="(item, index) in messagelist" :key="index" class="li">
                            <div class="elrow flex">
                                <div class="sculpture">
                                    <img class="sculpture-img" fit="cover" src="../assets/mesicon@2x.png" />
                                    <div class="username">{{ item.time }} </div>
                                </div>
                                <div class="single_line">
                                    {{ item.msg }}
                                </div>
                                <div class="disable"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name: 'Index',
    data() {
        return {
            tableData: [],
            tableData1: [],
            tableData2: [],
            tableData3: [],
            rightdata: [],
            showIndex1: 0,
            showIndex2: 0,
            showIndex3: 0,
            animate: false,
            items: [
                {
                    agentId: "5acc318e4966b479585767c2",
                    img: "https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/certificate/202012/5fd20004787ae5944003fbf2.ico",
                    msg: "abc111h哈哈哈哈哈哈哈哈哈哈哈啊哈哈哈哈哈哈哈哈哈哈啊哈哈哈超超超超超超哈哈哈哈",
                    name: "林东茶1",
                },
                {
                    agentId: "5acc318e4966b479585767c2",
                    img: "https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/certificate/202012/5fd20004787ae5944003fbf2.ico",
                    msg: "abc111",
                    name: "林东茶2222",
                }
            ],
            messagelist_total: [],
            total: '',
            messagelist: [],
            showmask: false,
            arr: {
                one: [],
                two: []
            },
            topic: '6475c7baae3b2ca776ddc9d4'
            // 646c731e805d73850ae6c188
        }
    },
    created() {
        // this.getData()
        // setInterval(() => {
        //     this.getData()
        // }, 2000);
        // this.init()
        this.newMqtt()
    },
    destroyed() {
        this.$mqtt.end()
    },
    methods: {
        newMqtt() {
            // this.$mqtt.subscribe('eggCount', { qos: 0 }, (err, granted) => {
            //     if (err) {
            //         console.error(err)
            //     } else {
            //         console.log('Subscribed to topic', granted[0].topic)
            //     }
            // })
            this.$mqtt.subscribe('screenData'+ this.topic, { qos: 0 }, (err, granted) => {
                if (err) {
                    console.error(err)
                } else {
                    axios.get('https://app.hkaspire.cn/report/public/screen/data/' + this.topic)
                    console.log('Subscribed to topic', granted[0].topic)
                }
            })
            this.$mqtt.on('message', (topic, message, packet) => {
                switch (topic) {
                    case 'eggCount':
                        // console.log(message.toString(), 'message')
                        // this.messagelist.push(JSON.parse(message.toString()))
                        // let kidsboxlist = document.getElementsByClassName('elrow')
                        // let that = this
                        // Array.prototype.forEach.call(kidsboxlist, function (item) {
                        //     console.log(item.offsetTop, kidsboxlist, 'item.offsetTop')
                        //     if (item.offsetTop < 60) {
                        //         that.showmask = true
                        //     }
                        // })
                        // break
                    case 'screenData'+ this.topic:
                        console.log(JSON.parse(message.toString()), 'tableData1')
                        // this.total = (JSON.parse(message.toString()).total).toFixed(2)
                        this.tableData = JSON.parse(message.toString()).data
                        this.tableData1 = JSON.parse(message.toString()).data
                }
            })

            this.$mqtt.on('reconnect', (error) => {
                console.log('正在重连:', error)
                if (!error) {
                    axios.get('https://app.hkaspire.cn/report/public/screen/data/' + this.topic)
                }
            })
            setTimeout(() => {
                this.list()
            }, 1000)
        },
        list() {
            var count = 1
            this.tableData2 = this.tableData.slice(10 * count)
            this.tableData3 = this.tableData.slice(10 * (count + 1))
            setInterval(() => {
                if (this.tableData < 10) {
                    return
                }
                this.tableData2 = this.tableData.slice(10 * count)
                this.tableData3 = this.tableData.slice(10 * (count + 1))
                count += 2
                if (this.tableData3.length <= 10) {
                    count = 1
                }
            }, 5000);
        },
        thousands(number) {
            let arr = String(number).split('.');
            let num = arr[0];
            let len = Math.ceil(num.length / 3) * 3;
            let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '');
            return arr[1] ? result + '.' + arr[1] : result;
        },

        async init() {
            await this.getmsg()
            setInterval(() => {
                this.getmsg()
            }, 10000);
            await this.getScrollMessage()
        },
        getmsg() {
            return new Promise((resolve) => {
                axios.get('https://app.hkaspire.cn/report/public/message').then((res) => {
                    if (res.data.data) {
                        console.log(res.data.data, 'res.data.data')
                        res.data.data.map((item) => {
                            this.messagelist_total.push(item)
                        })
                    }
                    this.messagelist_total.push({ time: '12:32', msg: '大家好压压压压与呀呀呀呀呀呀就将计就计！' })
                    resolve()
                })
            })

        },
        async scroll() {
            if (this.messagelist_total.length > 0) {
                setInterval(() => {
                    let item = this.messagelist_total.shift()
                    if (item) {
                        this.messagelist.push(item)
                    }
                }, 1500);
            }
        },
        cs() {
            setTimeout(() => {
                this.items.map((item) => {
                    this.messagelist.push(item)
                })
            }, 500)
        },
        getScrollMessage() {
            //这里用网络请求替换真实数据，把下面的代码放到响应成功的线程里
            let that = this
            setInterval(() => {
                let kidsboxlist = document.getElementsByClassName('elrow')
                Array.prototype.forEach.call(kidsboxlist, function (item) {
                    if (item.offsetTop < 10) {
                        that.showmask = true
                    }
                })
                this.scroll()
            }, 1000);
        },
        async getData() {
            //644651245da6cd30ed32b45e 正式
            //6445f958783da5f6267cbf6b 测试
            //https://app.hkaspire.cn
            //http://192.168.80.51 测试
            await axios.get('https://app.hkaspire.cn/report/public/sale_conf_result?id=644651245da6cd30ed32b45e').then((res) => {
                this.tableData = res.data.data;
                this.total = res.data.total
                if (this.tableData && this.tableData.length > 0) {
                    this.tableData.forEach((item, index) => {
                        if (String(item.value).indexOf(".") > -1) {
                            item.value = item.value.toFixed(2)
                        }
                        item.sort = index + 1
                    })
                }
            })
            this.listHandle()
        },
        listHandle() {
            let list = []
            list = this.tableData
            this.tableData1 = this.tableData.slice(0, 10)
            console.log(list, 'list.length ')
            let listnew = this.tableData.slice(10)
            if (list.length > 10) {
                this.listHandle2(listnew)
            }
        },
        listHandle2(list) {
            console.log(list, '666')
            let recordIndex = 1
            const listObj = list.reduce((initVal, item, index) => {
                if (initVal[recordIndex]) {
                    initVal[recordIndex].push(item)
                } else {
                    initVal[recordIndex] = [item]
                }
                if ((index + 1) % 10 === 0) {
                    console.log(111)
                    if (recordIndex >= 2) recordIndex = 1
                    else recordIndex++
                }
                return initVal
            }, {})
            console.log(listObj, 'listObj')
            listObj.one = listObj['1']
            listObj.two = listObj['2']
            delete listObj['1']
            delete listObj['2']
            this.changetable1(listObj)
        },
        changetable(lists) {
            let { showIndex1 = 0, showIndex2 = 0 } = this
            let list = JSON.parse(JSON.stringify(lists))
            this.arr = JSON.parse(JSON.stringify(lists))
            console.log(list, this.arr, showIndex1, showIndex2, 'this.rightdata[1]')
            this.tableData2 = []
            this.tableData3 = []
            if (list.one) {
                this.tableData2 = list.one.splice(showIndex1, 10)
            } else {
                this.tableData2 = []
            }
            if (list.two) {
                this.tableData3 = list.two.splice(showIndex1, 10)
            } else {
                this.tableData3 = []
            }
            if (list.one && list.one.length > 0) {
                this.showIndex1 = (showIndex1 + 10 > list.one.length) ? 0 : showIndex1 + 10
            }
            if (list.two && list.two.length) {
                this.showIndex2 = (showIndex2 + 10 > list.two.length) && (showIndex1 + 10 > list.one.length) ? 0 : showIndex2 + 10
            }
        },
        changetable1(list) {
            setInterval(() => {
                this.changetable(list)
            }, 10000)
            this.changetable(list)
        }
    }
}
</script>
  
<style lang="scss">
html {
    font-size: 12px;
}

.flex {
    display: flex;
}

.home {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 13rem 5.83rem 12.5rem 5.83rem;
    background: url('../assets/bg@2x.png') no-repeat;
    background-size: 100% 100%;

    .content {
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        height: 100%;
        width: 100%;
        position: relative;
        background: url('../assets/bg2@2x.png') no-repeat;
        background-size: 100% 100%;

        .total_title {
            display: flex;
            align-items: center;
            position: absolute;
            top: -6.75rem;
            left: 0;

            .label {
                width: 15.92rem;
                height: 5.5rem;
                margin-right: 2.5rem;
            }

            .text {
                font-size: 3.17rem;
                font-family: AlibabaPuHuiTiM;
                color: #000000;
                line-height: 4.33rem;
            }
        }

        .first_list {
            box-sizing: border-box;
            width: 32.5%;
            height: 100%;
            padding: 0.87% 0.95%;
            // margin-top: -3.0px;
            // align-items: center;
            display: flex;
            // justify-content: center;

            .content_item {
                width: 100%;
                padding: 0 0;

                .column {
                    height: 9.8%;

                    .icongroup {
                        width: 30px;
                        height: 30px;
                        margin-top: 2px;
                    }
                }

                //height: 280.0px;
            }

            .imgicon {
                width: 86.7px;
                height: 54.6px;
                font-size: 9.4px;
                font-family: AlibabaPuHuiTiM;
                color: #FFFFFF;
                line-height: 11.0px;
                position: absolute;
                top: 0;
                left: 0;

                img {
                    height: 100%;
                    width: 100%;
                }

                .total_txt {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 52.0px;
                    height: 33.1px;
                    font-size: 9.4px;
                    font-family: AlibabaPuHuiTiM;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    text-align: center;

                    div {
                        transform: rotate(-20deg);
                        margin-left: -4px;
                        margin-top: -2px;
                    }
                }
            }
        }

        .list_right {
            box-sizing: border-box;
            width: 32.5%;
            height: 100%;
            padding: 0.87% 0.95%;
        }

        .content_item {
            width: 100%;
            height: 100%;
            padding: 0 0;

            .table {
                overflow: hidden;

                .title_first {
                    width: 100%;
                    text-align: center;
                }

                .column_content {
                    height: 87.3%;
                }

                .column {
                    width: 100%;
                    height: 9.8%;
                    // font-size: 24px;
                    text-align: center;

                    &.header {
                        height: 12.7%;

                        .el-row {
                            height: 100%;
                        }
                    }

                    .el-row {
                        display: flex;
                        justify-content: space-around;
                        height: 100%;
                        padding-right: 4%;
                        align-items: center;
                    }

                    .label {
                        height: 21px;

                        .xh,
                        .jf {
                            // width: 41px;
                            height: 21px;
                        }

                        .tzb {
                            // width: 102px;
                        }

                    }

                    .label-value {

                        font-size: 18px;
                        font-family: AlibabaPuHuiTiM;
                        // font-weight: 600;
                        color: #333333;

                        &.integral {
                            width: 100%;
                            text-align: center;
                        }

                    }
                }
            }

        }

        .scroll {
            position: fixed;
            bottom: 0;
            left: 0;
            /*几个高度要一致*/
            height: 50vh;
            width: 15.5%;
            // width: 100vw;
            font-family: SourceHanSansSC-Regular;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0vw;
            letter-spacing: 0vw;
            color: #666666;
            overflow: hidden;
            z-index: 10000;
            padding-left: 10px;
            padding-bottom: 3%;
            box-sizing: border-box;
            border-radius: 10px;

            // border-top:10px solid linear-gradient(180deg, #FFECF1 0%, rgba(255,246,248,0) 100%);
            .mask {
                position: absolute;
                background: linear-gradient(180deg, #F0EEF1 0%, rgba(240, 238, 241, 0) 100%);
                top: 0;
                left: 0;
                border-radius: 10px;
                width: 100%;
                height: 15%;
                z-index: 10000;
            }

            .disable {
                display: none;
            }
        }

        .backlinear {
            // background: linear-gradient(180deg, #FFECF1 0%, rgba(255, 246, 248, 0) 100%);

        }

        .shedow {
            position: absolute;
            top: vh(-150);
            left: 0;
            height: vh(200);
            width: 100%;
            box-shadow: getRem(-100) 0px getRem(100) getRem(100) #F0EEF1;
            z-index: 100000;
            // background: linear-gradient(180deg, #F0EEF1 0%, rgba(240,238,241,0) 100%);
            // box-shadow:-10px 0px 10px 1px #000;
        }

        .anim {
            transition: all 0.5s;
            /*几个高度要一致*/
            margin-top: -40px;
        }

        #ulll {
            padding: 0 !important;
            width: 100%;
            // overflow-y: scroll;
            // scrollbar-width: none;
            // -ms-overflow-style: none !important;

            // &::-webkit-scrollbar {

            //     display: none;
            //     /* Chrome Safari */

            // }


            li {
                list-style: none;
                margin: 12px 0;
            }

        }

        .background {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            height: 100%;
        }

        .elrow {
            // width: 258px;
            width: fit-content;
            // height: 66px;
            background: rgb(0, 0, 0, .2);
            padding: 8px;
            box-sizing: border-box;
            border-radius: 10px;
            align-items: center;
            position: relative;
        }

        .single_line {
            line-height: 25px;
            font-size: 18px;
            color: #FFFFFF;
            // padding-left:10px;
            margin-left: 12px;
            // flex: 1;
            max-width: 100%;
            z-index: 1000;
            display: flex;
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            // width: 100%;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            word-break: break-all;
        }

        .sculpture {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            height: 50px;

            .sculpture-img {
                width: 17px;
                height: 17px;
                // margin-left:7.8px;
                border-radius: 50%
            }
        }

        .username {
            font-size: 11px;
            font-family: AlibabaPuHuiTiR;
            color: #FFFFFF;
            line-height: 16px;
        }

    }
}

::v-deep .el-table {
    .el-table__row {
        background: #F0EEF1;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background: #E5E9F0;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/views/newIndex.vue